import api from '../api';
import analyticsService from '../analyticsService';
import {unauthorize, getRefreshToken} from './authorization';
import {removeCookie} from '../helpers/cookies';
import {CookieNames} from '../generalTypes';
import {DASHBOARD_URL} from '../constants';

export const logOut = () => async (dispatch: any) => {
    dispatch(unauthorize());
    dispatch(api.util.resetApiState());

    removeCookie(CookieNames.accessToken);
    removeCookie(CookieNames.refreshToken);

    analyticsService.reset();

    window.location.replace(DASHBOARD_URL);
};

export const refreshAuthToken = () => async (dispatch: any, getState: any) => {
    const state = getState();
    const refreshToken = getRefreshToken(state);
    const {error, data} = await dispatch(api.endpoints.refreshToken.initiate({sso_token: refreshToken as string}));

    return {isSuccess: !error, data};
};
